var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b23ca6ad31884923e21638fff03e577e17195678"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engine-frontend@apollograph"]={id:"b23ca6ad31884923e21638fff03e577e17195678"};
      